export const PAYMENT_MODES = {
  DUE: 'due',
  PARTIAL: 'partial',
  FULL_PAYOFF: 'fullPayoff',
} as const;

export type PaymentMode = typeof PAYMENT_MODES[keyof typeof PAYMENT_MODES];
